import { Component} from "@angular/core";
import { UserAuthenticationService, CurrentUserService } from "../../../services/shared";

@Component({
    selector: "header-component",
    template: require("./header.component.html"),
    styles: [require("./header.component.less").toString()]
})

export class HeaderComponent {
    isError: boolean;
    isAuthenticated: boolean;
    isQA:boolean;
    constructor(public userAuthService: UserAuthenticationService, public currentUserService: CurrentUserService) {
        try {
            this.isAuthenticated = userAuthService.isAuthenticated;
            this.isError = false;
        } catch (e) {
            this.isError = true;
        }
        
        this.isQA = (process.env.ENV === 'qa' || process.env.ENV === 'development')
    }

    public logout() {
        this.userAuthService.Logout();
    }
}


// WEBPACK FOOTER //
// ./src/app/components/shared/header/header.component.ts